import React from 'react';
import { FiX } from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = ({
    isOpen,
    onClose,
    conversations,
    selectedChat,
    onNewChatClick,
    onChatClick
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <>
            <div className="sidebar-overlay" onClick={onClose} />
            <aside className="sidebar-drawer">
                <div className="sidebar-header">
                    <span>Menu</span>
                    <button onClick={onClose} title="Cerrar menú" className="icon-button">
                        <FiX size={18} />
                    </button>
                </div>
                <nav className="sidebar-nav">
                    <a href="#" className="sidebar-link new-chat-link" onClick={onNewChatClick}>
                        New Chat
                    </a>
                    {conversations.map((conv, index) => (
                        <button
                            key={index}
                            className={`sidebar-link conversation-button ${selectedChat === conv.url ? 'selected' : ''}`}
                            onClick={() => onChatClick(conv.url)}
                        >
                            {conv.url || `Chat Historial ${index + 1}`}
                        </button>
                    ))}
                </nav>
            </aside>
        </>
    );
};

export default Sidebar;